"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DCAutoOrderBillState = exports.DCAutoOrderBillType = exports.DCTransferType = exports.DCAutoPrepareState = exports.DCAutoOrderSubState = exports.TrueDCAutoStrategyState = exports.DCAutoStrategyState = exports.DCAutoSubOrderType = exports.DCAutoOrderType = void 0;
var DCAutoOrderType;
(function (DCAutoOrderType) {
    DCAutoOrderType["dual_auto"] = "dual_auto";
})(DCAutoOrderType = exports.DCAutoOrderType || (exports.DCAutoOrderType = {}));
var DCAutoSubOrderType;
(function (DCAutoSubOrderType) {
    DCAutoSubOrderType["price_limit"] = "price_limit";
    DCAutoSubOrderType["target_return"] = "target_return";
    DCAutoSubOrderType["price_limit_bound"] = "price_limit_bound";
})(DCAutoSubOrderType = exports.DCAutoSubOrderType || (exports.DCAutoSubOrderType = {}));
var DCAutoStrategyState;
(function (DCAutoStrategyState) {
    DCAutoStrategyState["init"] = "init";
    DCAutoStrategyState["running"] = "running";
    DCAutoStrategyState["closed"] = "closed";
})(DCAutoStrategyState = exports.DCAutoStrategyState || (exports.DCAutoStrategyState = {}));
var TrueDCAutoStrategyState;
(function (TrueDCAutoStrategyState) {
    TrueDCAutoStrategyState["init"] = "init";
    TrueDCAutoStrategyState["running"] = "running";
    TrueDCAutoStrategyState["closed"] = "closed";
    TrueDCAutoStrategyState["waitRelease"] = "wait_release";
})(TrueDCAutoStrategyState = exports.TrueDCAutoStrategyState || (exports.TrueDCAutoStrategyState = {}));
var DCAutoOrderSubState;
(function (DCAutoOrderSubState) {
    DCAutoOrderSubState["running"] = "running";
    DCAutoOrderSubState["changed"] = "changed";
    DCAutoOrderSubState["user_closed"] = "user_closed";
    DCAutoOrderSubState["undeal_closed"] = "undeal_closed";
})(DCAutoOrderSubState = exports.DCAutoOrderSubState || (exports.DCAutoOrderSubState = {}));
/**
 * 复投预执行状态
 */
var DCAutoPrepareState;
(function (DCAutoPrepareState) {
    DCAutoPrepareState["none"] = "none";
    DCAutoPrepareState["prepare_close"] = "prepare_close";
    DCAutoPrepareState["prepare_collect"] = "prepare_collect";
    DCAutoPrepareState["prepare_release"] = "prepare_release";
    DCAutoPrepareState["prepare_transfer"] = "prepare_transfer";
    DCAutoPrepareState["prepare_transfer_cancel"] = "prepare_transfer_cancel";
    DCAutoPrepareState["prepare_close_cancel"] = "prepare_close_cancel";
    DCAutoPrepareState["prepare_revoke"] = "prepare_revoke";
})(DCAutoPrepareState = exports.DCAutoPrepareState || (exports.DCAutoPrepareState = {}));
var DCTransferType;
(function (DCTransferType) {
    DCTransferType["transfer_in"] = "transfer_in";
    DCTransferType["transfer_out"] = "transfer_out";
})(DCTransferType = exports.DCTransferType || (exports.DCTransferType = {}));
/**
 * 复投订单详情账单类型
 */
var DCAutoOrderBillType;
(function (DCAutoOrderBillType) {
    DCAutoOrderBillType["invest"] = "invest";
    DCAutoOrderBillType["income"] = "income";
    DCAutoOrderBillType["revoke"] = "revoke";
    DCAutoOrderBillType["changed"] = "changed";
    DCAutoOrderBillType["transferIn"] = "transfer_in";
    DCAutoOrderBillType["transferOut"] = "transfer_out";
})(DCAutoOrderBillType = exports.DCAutoOrderBillType || (exports.DCAutoOrderBillType = {}));
/**
 * 复投订单详情账单状态
 */
var DCAutoOrderBillState;
(function (DCAutoOrderBillState) {
    DCAutoOrderBillState["unsettle"] = "UNSETTLE";
    DCAutoOrderBillState["settled"] = "SETTLED";
    DCAutoOrderBillState["cancel"] = "CANCEL";
    DCAutoOrderBillState["failed"] = "FAILED";
})(DCAutoOrderBillState = exports.DCAutoOrderBillState || (exports.DCAutoOrderBillState = {}));
